import type { IncomingDocument, CRMSuggestion, ReportTemplate } from '@/types/documentIngestion'

export const INCOMING_DOCUMENTS: IncomingDocument[] = [
  {
    id: 'DOC-IN-001',
    source: 'email',
    senderEmail: 'mthompson@antarcticacapital.com',
    senderName: 'Michael Thompson',
    subject: 'Re: Riverwalk Tempe - Updated Rent Roll Q1 2026',
    receivedAt: '2026-03-22T14:30:00Z',
    fileName: 'Riverwalk_RentRoll_Q1_2026.xlsx',
    fileType: 'xlsx',
    fileSize: '2.4 MB',
    status: 'extracted',
    dealId: 'ALG-1016',
    documentType: 'Rent Roll',
    extractedFields: {
      'Total Units': 320,
      'Occupancy': '94.2%',
      'Avg Rent/Unit': '$1,842',
      'Total Monthly Revenue': '$562,214',
      'Lease Expirations (6mo)': 42,
    },
    confidence: 0.94,
  },
  {
    id: 'DOC-IN-002',
    source: 'email',
    senderEmail: 'appraisals@cushwake.com',
    senderName: 'Cushman & Wakefield Valuation',
    subject: 'Appraisal Report - One Congress Plaza, Austin TX',
    receivedAt: '2026-03-22T10:15:00Z',
    fileName: 'OneCongressPlaza_Appraisal_Final.pdf',
    fileType: 'pdf',
    fileSize: '8.7 MB',
    status: 'parsing',
    dealId: 'ALG-1018',
    documentType: 'Appraisal',
    confidence: 0.87,
  },
  {
    id: 'DOC-IN-003',
    source: 'upload',
    receivedAt: '2026-03-21T16:45:00Z',
    fileName: '2025_Annual_Financials_GreenValley.pdf',
    fileType: 'pdf',
    fileSize: '3.1 MB',
    status: 'validated',
    dealId: 'ALG-1019',
    documentType: 'Financial Statement',
    extractedFields: {
      'Revenue': '$4,250,000',
      'Operating Expenses': '$1,680,000',
      'NOI': '$2,570,000',
      'Cap Rate': '5.85%',
      'Occupancy': '96.1%',
    },
    confidence: 0.96,
  },
  {
    id: 'DOC-IN-004',
    source: 'email',
    senderEmail: 'schen@borrowergroup.com',
    senderName: 'Sarah Chen',
    subject: 'Fwd: Environmental Phase I - Midtown Industrial Park',
    receivedAt: '2026-03-21T09:20:00Z',
    fileName: 'PhaseI_ESA_MidtownIndustrial.pdf',
    fileType: 'pdf',
    fileSize: '12.3 MB',
    status: 'received',
    documentType: 'Environmental',
    confidence: 0.72,
  },
  {
    id: 'DOC-IN-005',
    source: 'email',
    senderEmail: 'jmorales@titaninsurance.com',
    senderName: 'Juan Morales',
    subject: 'Insurance Renewal - Riverwalk Property',
    receivedAt: '2026-03-20T11:00:00Z',
    fileName: 'Insurance_Certificate_Riverwalk_2026.pdf',
    fileType: 'pdf',
    fileSize: '1.2 MB',
    status: 'filed',
    dealId: 'ALG-1016',
    documentType: 'Insurance',
    extractedFields: {
      'Policy Number': 'TI-2026-44891',
      'Coverage Amount': '$45,000,000',
      'Premium': '$128,500',
      'Effective Date': '04/01/2026',
      'Expiration': '03/31/2027',
    },
    confidence: 0.98,
  },
  {
    id: 'DOC-IN-006',
    source: 'api',
    receivedAt: '2026-03-20T08:30:00Z',
    fileName: 'Title_Commitment_SunbeltLogistics.pdf',
    fileType: 'pdf',
    fileSize: '4.5 MB',
    status: 'extracted',
    dealId: 'ALG-1020',
    documentType: 'Title',
    extractedFields: {
      'Title Company': 'First American Title',
      'Commitment Number': 'FA-2026-77214',
      'Property Address': '4500 Logistics Blvd, Dallas TX',
      'Exceptions': 3,
      'Requirements': 5,
    },
    confidence: 0.91,
  },
  {
    id: 'DOC-IN-007',
    source: 'email',
    senderEmail: 'kpatel@greenvalleypartners.com',
    senderName: 'Kiran Patel',
    subject: 'Tax Returns - 2024 & 2025',
    receivedAt: '2026-03-19T15:20:00Z',
    fileName: 'GreenValley_TaxReturns_2024_2025.pdf',
    fileType: 'pdf',
    fileSize: '6.8 MB',
    status: 'validated',
    documentType: 'Tax Return',
    extractedFields: {
      'Entity': 'Green Valley Partners LLC',
      'Filing Year': '2025',
      'Total Income': '$5,180,000',
      'Taxable Income': '$2,840,000',
      'Entity Type': 'Partnership (1065)',
    },
    confidence: 0.89,
  },
]

export const CRM_SUGGESTIONS: CRMSuggestion[] = [
  {
    id: 'CRM-SUG-001',
    name: 'Sarah Chen',
    company: 'BorrowerGroup Capital',
    email: 'schen@borrowergroup.com',
    phone: '(512) 555-0142',
    role: 'Managing Partner',
    sourceDocumentId: 'DOC-IN-004',
    sourceType: 'email_signature',
    status: 'suggested',
    dealAssociations: ['ALG-1019'],
  },
  {
    id: 'CRM-SUG-002',
    name: 'Juan Morales',
    company: 'Titan Insurance Group',
    email: 'jmorales@titaninsurance.com',
    phone: '(602) 555-0289',
    role: 'Senior Account Manager',
    sourceDocumentId: 'DOC-IN-005',
    sourceType: 'email_signature',
    status: 'reviewed',
    dealAssociations: ['ALG-1016'],
  },
  {
    id: 'CRM-SUG-003',
    name: 'Kiran Patel',
    company: 'Green Valley Partners',
    email: 'kpatel@greenvalleypartners.com',
    role: 'Principal',
    sourceDocumentId: 'DOC-IN-007',
    sourceType: 'email_signature',
    status: 'suggested',
    dealAssociations: ['ALG-1019'],
  },
]

export const REPORT_TEMPLATES: ReportTemplate[] = [
  {
    id: 'RPT-001',
    name: 'Annual Surveillance Report',
    type: 'ASR',
    frequency: 'Annual',
    recipients: ['portfolio-team@helios.com', 'risk@helios.com'],
    format: 'PDF',
    lastGenerated: '2026-01-15',
    nextScheduled: '2027-01-15',
    enabled: true,
  },
  {
    id: 'RPT-002',
    name: 'Quarterly Portfolio Summary',
    type: 'Quarterly Summary',
    frequency: 'Quarterly',
    recipients: ['leadership@helios.com', 'investors@helios.com'],
    format: 'Both',
    lastGenerated: '2026-01-01',
    nextScheduled: '2026-04-01',
    enabled: true,
  },
  {
    id: 'RPT-003',
    name: 'Investor Package Q1 2026',
    type: 'Investor Package',
    frequency: 'Quarterly',
    recipients: ['ir@helios.com'],
    format: 'PDF',
    lastGenerated: '2025-10-01',
    nextScheduled: '2026-04-15',
    enabled: true,
  },
  {
    id: 'RPT-004',
    name: 'Weekly Pipeline Digest',
    type: 'Custom',
    frequency: 'Weekly',
    recipients: ['originations@helios.com'],
    format: 'PDF',
    lastGenerated: '2026-03-17',
    nextScheduled: '2026-03-24',
    enabled: true,
  },
  {
    id: 'RPT-005',
    name: 'Monthly Risk Dashboard',
    type: 'Custom',
    frequency: 'Monthly',
    recipients: ['risk@helios.com', 'cro@helios.com'],
    format: 'Excel',
    lastGenerated: '2026-03-01',
    nextScheduled: '2026-04-01',
    enabled: false,
  },
]
